import { Linkedin } from "lucide-react";
import type { Company } from "../api/HiringContactsApi";
import { useHiringContacts } from "../modal/HiringContactsContext";
import AssignEntityModal from "./AssignEntityModal";

interface Props {
  company: Company;
  onClose: () => void;
}

export default function AssignCompanyModal({ company, onClose }: Props) {
  const { companyAssignees, loadCompanyAssignees, handleAssignCompany, handleUnassignCompany } = useHiringContacts();

  return (
    <AssignEntityModal
      title="Assign Company"
      subject={
        <>
          <p className="text-sm font-semibold text-foreground font-inter inline-flex items-center gap-1.5">
            {company.name}
            {company.linkedin_url && (
              <a href={company.linkedin_url} target="_blank" rel="noreferrer" className="text-sky-400">
                <Linkedin className="w-3.5 h-3.5" />
              </a>
            )}
          </p>
          <p className="text-xs text-muted-foreground font-inter mt-0.5">{company.domain}</p>
        </>
      }
      assignees={companyAssignees}
      onLoadAssignees={() => loadCompanyAssignees(company.id)}
      onAssign={(employeeIds) => handleAssignCompany(company.id, employeeIds)}
      onUnassign={(assignmentId) => handleUnassignCompany(assignmentId, company.id)}
      onClose={onClose}
    />
  );
}
